import { SECTION_LABELS } from '@blisspointmedia/bpm-types/dist/GoogleAdsAudit';
import {
  SECTION_CHECK_COUNTS,
  SECTION_ICONS,
  SECTION_ORDER,
  TOTAL_CHECK_COUNT
} from '../google-ads-audit-constants';

export const CoverageOverview = () => (
  <div className='google-ads-audit-coverage'>
    <div className='google-ads-audit-section-title'>
      Audit coverage — {TOTAL_CHECK_COUNT} checks across {SECTION_ORDER.length} areas
    </div>
    <div className='google-ads-audit-coverage-grid'>
      {SECTION_ORDER.map(sectionId => {
        const Icon = SECTION_ICONS[sectionId];
        return (
          <div key={sectionId} className='google-ads-audit-coverage-item'>
            <Icon className='google-ads-audit-coverage-icon' />
            <span className='google-ads-audit-coverage-label'>{SECTION_LABELS[sectionId]}</span>
            <span className='google-ads-audit-coverage-count'>
              {SECTION_CHECK_COUNTS[sectionId]} checks
            </span>
          </div>
        );
      })}
    </div>
  </div>
);
